import '../interface_builder/bootstrap';
import React from 'react';
import { createRoot } from 'react-dom/client';
import AppListing from '../interface_builder/composer/AppListing';

const element = React.createElement(AppListing);
const rootNode = document.createElement('div');
document.body.appendChild(rootNode);
const root = createRoot(rootNode!);
root.render(element);
